import * as z$1 from "zod/v4";
//#region src/schemas/http/auth-device-authorization.ts
const BETTER_AUTH_DEVICE_AUTHORIZATION_GRANT_TYPE = "urn:ietf:params:oauth:grant-type:device_code";
const betterAuthDeviceAuthorizationCodeRequestSchema = z$1.object({
	client_id: z$1.string().min(1),
	scope: z$1.string().optional(),
	user_id: z$1.string().optional()
});
const betterAuthDeviceAuthorizationCodeResponseSchema = z$1.object({
	device_code: z$1.string().min(1),
	user_code: z$1.string().min(1),
	verification_uri: z$1.string().min(1),
	verification_uri_complete: z$1.string().min(1),
	expires_in: z$1.number().finite().positive(),
	interval: z$1.number().finite().positive()
});
const betterAuthDeviceAuthorizationStatusSchema = z$1.enum([
	"pending",
	"approved",
	"denied"
]);
const betterAuthDeviceAuthorizationClaimResponseSchema = z$1.object({
	user_code: z$1.string().min(1),
	status: betterAuthDeviceAuthorizationStatusSchema
});
const betterAuthDeviceAuthorizationDecisionRequestSchema = z$1.object({ userCode: z$1.string().min(1) });
const betterAuthDeviceAuthorizationDecisionResponseSchema = z$1.object({ success: z$1.boolean() });
const betterAuthDeviceAuthorizationTokenRequestSchema = z$1.object({
	grant_type: z$1.literal(BETTER_AUTH_DEVICE_AUTHORIZATION_GRANT_TYPE),
	device_code: z$1.string().min(1),
	client_id: z$1.string().min(1)
});
const betterAuthDeviceAuthorizationTokenResponseSchema = z$1.object({
	access_token: z$1.string().min(1),
	token_type: z$1.string().min(1),
	expires_in: z$1.number().finite().positive(),
	scope: z$1.string()
});
const betterAuthDeviceAuthorizationErrorResponseSchema = z$1.object({
	error: z$1.string().optional(),
	error_description: z$1.string().optional(),
	message: z$1.string().optional(),
	detail: z$1.string().optional()
});
const betterAuthSessionUserSnapshotSchema = z$1.object({
	id: z$1.string().optional(),
	email: z$1.string().optional(),
	name: z$1.string().optional()
});
const betterAuthSessionSnapshotResponseSchema = z$1.nullable(z$1.object({
	session: z$1.unknown().optional(),
	user: betterAuthSessionUserSnapshotSchema.nullable()
}));
//#endregion
export { BETTER_AUTH_DEVICE_AUTHORIZATION_GRANT_TYPE, betterAuthDeviceAuthorizationClaimResponseSchema, betterAuthDeviceAuthorizationCodeRequestSchema, betterAuthDeviceAuthorizationCodeResponseSchema, betterAuthDeviceAuthorizationDecisionRequestSchema, betterAuthDeviceAuthorizationDecisionResponseSchema, betterAuthDeviceAuthorizationErrorResponseSchema, betterAuthDeviceAuthorizationStatusSchema, betterAuthDeviceAuthorizationTokenRequestSchema, betterAuthDeviceAuthorizationTokenResponseSchema, betterAuthSessionSnapshotResponseSchema, betterAuthSessionUserSnapshotSchema };

//# sourceMappingURL=auth-device-authorization.js.map